import React from "react";

import { Typography as AntTypography } from "antd";

const TypographyText = AntTypography.Text;

export type TypographyVariant =
  | "paragraph-xs"
  | "paragraph-s"
  | "paragraph-m"
  | "paragraph-l"
  | "paragraph-xl"
  | "hero"
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6";
export type TextColor = "grey-600" | "green-400" | "red-500" | "white";

type TypographyProps = Omit<React.ComponentProps<typeof TypographyText>, "className"> & {
  variant: TypographyVariant;
  color?: TextColor;
  className?: string;
  bold?: boolean;
  hero?: boolean;
  noWrap?: boolean;
};

export const Typography = ({ variant, color, bold, noWrap, hero, className, ...props }: TypographyProps) => (
  <TypographyText
    {...props}
    className={[variant, hero && "hero", bold && `${variant}-bold`, noWrap && "no-wrap", color, className].filter(Boolean).join(" ")}
  />
);
